import { render, staticRenderFns } from "./SupplierGalleryForm.vue?vue&type=template&id=89a61f76&"
import script from "./SupplierGalleryForm.vue?vue&type=script&lang=js&"
export * from "./SupplierGalleryForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports